
import React from "react";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabContentWithImage } from "./TabContent";

interface LearningMenuProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  allImagesLoaded: boolean;
}

export const LearningMenu: React.FC<LearningMenuProps> = ({
  activeTab,
  onTabChange,
  allImagesLoaded
}) => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-gray-200 text-primary text-sm font-medium">Learning</NavigationMenuTrigger>
      <NavigationMenuContent className="w-[95vw] min-w-[95vw] max-w-[1000px] h-[500px] bg-white rounded-md shadow-lg p-4 border border-gray-200">
        <Tabs value={activeTab} onValueChange={onTabChange} orientation="vertical" className="flex">
          <TabsList className="flex flex-col w-1/4 h-[450px] bg-gray-50 rounded-l-md space-y-1 p-2 border-r border-primary portrait:w-1/4 portrait:min-w-[120px]">
            <TabsTrigger value="resources" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Resources
            </TabsTrigger>
            <TabsTrigger value="tutorials" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Tutorials
            </TabsTrigger>
            <TabsTrigger value="learningservices" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Learning Services
            </TabsTrigger>
          </TabsList>
          <TabsContent value="resources" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Resources"
              title="Learning Resources"
              description="Comprehensive collection of white papers, case studies, and research reports on AI implementation across various business functions."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="tutorials" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Tutorials"
              title="Tutorials"
              description="Step-by-step guides and video tutorials on maximizing the effectiveness of our AI solutions for your business needs."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="learningservices" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1513258496099-48168024aec0?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Learning Services"
              title="Learning Services"
              description="Customized training programs and workshops to help your team leverage our AI solutions effectively across the enterprise."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
        </Tabs>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
